import { axiosInstanceWithoutErrorModal } from '../assets/utils/axiosInstance';

type GetUserRoleSettingsResponseType = {
  is_only_allowed_to_view_assigned_report: boolean,
  is_allowed_to_reopen_report: boolean,
  is_allowed_to_request_pii_removal: boolean,
  is_allowed_to_redact_report: boolean,
  allowed_report_types: Array<{
    id: number,
    name: string,
    type: number,
    is_active: boolean,
    classification: string
  }>,
  is_read_only_report: boolean,
  is_allowed_to_create_final_report_template: boolean,
  is_allowed_to_download_final_report: boolean,
  is_allowed_to_download_attachments: boolean,
  allowed_tenants:Array<{
    id: number,
    name: string,
    slug: string,
    has_access: boolean
  }>,
  user_settings_invite_status: 'Pending' | 'Expired' | 'Accepted',
  invite_link_hours_remaining: number,
  is_invite_link_expired: boolean,
  email: string
};

type PostResendInvitationResponseType = {
  message: string
};

const postResendInvitation = async (userId: number): Promise<{ data: PostResendInvitationResponseType }> => {
  return new Promise((resolve, reject) => {
    axiosInstanceWithoutErrorModal().post<PostResendInvitationResponseType>(`/resend-invite-email/${userId}/resend-email`).then((response) => {
      resolve(response);
    }).catch(e => {
      reject(e);
    });
  });
};

const getUserRoleSettings = async (slug: string, userId: number): Promise<{ data: GetUserRoleSettingsResponseType }> => {
  return new Promise((resolve, reject) => {
    axiosInstanceWithoutErrorModal().get<GetUserRoleSettingsResponseType>(`/tenant/${slug}/users/${userId}/role-settings`).then((response) => {
      resolve(response);
    }).catch(e => {
      reject(e);
    });
  
  });
};
  
const userService = {
  getUserRoleSettings,
  postResendInvitation,
};
  
export default userService;